<template>
    <div v-if="!c_categoryBlock.calc_value" class="mb-2">
        <v-divider />
        <div class="d-flex flex-grow-1 flex-shrink-0 align-content-center justify-space-between mt-2 pb-4">
            <span class="font-weight-bold text-uppercase ">{{c_categoryBlock.label}}</span>
            <span v-if="c_categoryBlock.cat_type == 'multiple'" class="d-flex ">
                <v-btn v-if="!preview" @click="addRow">aggiungi configurazione</v-btn>
            </span>
            <span v-else>
                <NumericField
                    hide-details
                    dense outlined
                    :negative="true"
                    label="valore nominale"
                    v-model="c_categoryBlock.value"
                    :suffix="uom"/>
            </span>
        </div>
        <div v-if="c_categoryBlock.cat_type == 'multiple'">
            <div>
                <div v-for="(item, index) in c_categoryBlock.trials" :key="index">
                        <v-row no-gutters>
                            <v-col cols="6" class="d-flex flex-grow-1 flex-shrink-0 align-start">
                                <v-icon v-if="!preview" class="pr-2" @click="deleteRow(index)">delete</v-icon>
                                <NumericField dense outlined
                                    hide-details
                                    label="n° letture"
                                    v-model="item.values_nr"
                                    :precision="0"
                                    @change="buildTrialValues(item)"
                                />
                            </v-col>
                            <v-col cols="6" class="pl-2 pb-4" v-if="item.values.length > 0">
                                <v-simple-table class="dense elevation-1">
                                <thead>
                                    <tr>
                                        <th class="text-right">indice</th>
                                        <th class="text-right">valore nominale</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(value, index) in item.values" :key="index+'_'+item.values.length">
                                        <td>
                                            <span>{{index + 1}}</span>
                                        </td>
                                        <td class="pr-0 py-0">
                                        <NumericField
                                            dense outlined
                                            hide-details
                                            v-model="item.values[index]"
                                            :suffix="uom" />
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// // import _ from 'lodash'
import {getModel} from "../../utils/model"
export default {
    props:{
        category: {
            type: Object,
            required: true,
            default: null,
        }, 
        op_type: {
            type: String,
            required: true,
            default: ""
        },
        dict_key: {
            type: String,
            required: true,
            default: ""
        },
        uom: {
            type: String,
            required: false,
            default: ""
        },
        preview: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    created() {
        this.debouncedSave = _.debounce(function() {
            console.log('debouncedSave')
            if(!this.preview){
                this.saveValues()
            }
        }, 1000)
    },
    watch: {
        c_categoryBlock:{
            deep: true,
            handler(){
                this.debouncedSave()
            }
        },
        // default_value: {
        //     handler(){
        //         this.changeDefault()
        //     }
        // }
    },
    components: {},
    data() {
        return {
            c_categoryBlock: null,
            o_categoryBlock: null,
            type_of_values: [
                { id: 'perc', text: '%' },
                { id: 'div', text: 'divisioni' },
                { id: 'val', text: 'valore puntuale'}
            ],
            TrialDict: null,
        }
    },
    beforeMount(){
        this.o_categoryBlock = _.cloneDeep(this.category)
        this.c_categoryBlock = _.cloneDeep(this.category)
        this.TrialDict = getModel('TrialDict')
    },
    methods: {
        buildTrialValues(item){
            this.$set(item, 'values', Array(parseInt(item.values_nr)).fill(""))
        },
        saveValues(){
            this.$emit('updated', {op_type: this.op_type, values: this.c_categoryBlock, key: this.dict_key})
        },
        addRow(){
            this.c_categoryBlock.trials.push(this.TrialDict()) 
        },
        deleteRow(index){
            this.c_categoryBlock.trials.splice(index,1)
        },
        changeDefault(){
            console.log("category: changed default", this.c_categoryBlock)
            this.c_categoryBlock.calc_value = this.default_value
        }
    },

}
</script>